import { render, staticRenderFns } from "./NumberOfCases.vue?vue&type=template&id=59590606&scoped=true&"
import script from "./NumberOfCases.vue?vue&type=script&lang=js&"
export * from "./NumberOfCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59590606",
  null
  
)

export default component.exports